export default __webpack_public_path__ + "static/media/secondImageSlide.3f8fc306.png";